export default __webpack_public_path__ + "static/real-grad-right-e659a4644c9744a20f0caf8322d95b14.svg";